import React from "react";
import { Flex, Box, Text } from "@chakra-ui/react";

interface ChartLegendProps {
  items?: Array<{ name: string; color: string }>;
}

const ChartLegend: React.FC<ChartLegendProps> = ({ 
  items = [{ name: "Session Count", color: "#6366F1" }] 
}) => {
  return (
    <Flex justify="center" py={4}>
      {items.map((item, index) => (
        <Flex 
          key={index}
          alignItems="center" 
          bg="gray.200" 
          borderRadius="md" 
          py={1} 
          px={2}
          mx={1}
        >
          <Box 
            w="8px" 
            h="8px" 
            borderRadius="full" 
            bg={item.color} 
            mr={2}
          />
          <Text fontSize="xs" fontWeight="medium">
            {item.name}
          </Text>
        </Flex>
      ))}
    </Flex>
  );
};

export default ChartLegend; 